module.exports = new __parcel__URL__("../treeAnnotationRemoval.2300bcbb.png").toString();